var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-form-group",
        {
          attrs: {
            "invalid-feedback": _vm.error,
            label: _vm.__(_vm.config.name, ["titleCase"])
          }
        },
        [
          _vm.config.description
            ? _c("small", { staticClass: "form-text mb-2" }, [
                _vm._v(_vm._s(_vm.config.description))
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("input", {
            staticClass: "form-control",
            attrs: {
              type: _vm.showPassword ? "text" : "password",
              tabindex: _vm.position
            },
            domProps: { value: _vm.value },
            on: {
              input: function(e) {
                return _vm.onChange(e.target.value)
              }
            }
          }),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn btn-sm btn-rounded btn-success mt-2",
              attrs: { type: "button" },
              on: { click: _vm.generatePassword }
            },
            [_vm._v("Generate password")]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn btn-sm btn-rounded btn-default mt-2",
              attrs: { type: "button" },
              on: { click: _vm.toggleShowPassword }
            },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.showPassword,
                    expression: "showPassword"
                  }
                ],
                staticClass: "mr-1",
                attrs: { type: "checkbox" },
                domProps: {
                  checked: Array.isArray(_vm.showPassword)
                    ? _vm._i(_vm.showPassword, null) > -1
                    : _vm.showPassword
                },
                on: {
                  change: function($event) {
                    var $$a = _vm.showPassword,
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false
                    if (Array.isArray($$a)) {
                      var $$v = null,
                        $$i = _vm._i($$a, $$v)
                      if ($$el.checked) {
                        $$i < 0 && (_vm.showPassword = $$a.concat([$$v]))
                      } else {
                        $$i > -1 &&
                          (_vm.showPassword = $$a
                            .slice(0, $$i)
                            .concat($$a.slice($$i + 1)))
                      }
                    } else {
                      _vm.showPassword = $$c
                    }
                  }
                }
              }),
              _vm._v("Show password")
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "b-form-group",
        {
          attrs: { label: "Confirm " + _vm.__(_vm.config.name, ["titleCase"]) }
        },
        [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.confirm,
                expression: "confirm"
              }
            ],
            staticClass: "form-control",
            attrs: { type: "password", tabindex: _vm.position + 1 },
            domProps: { value: _vm.confirm },
            on: {
              input: [
                function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.confirm = $event.target.value
                },
                function(e) {
                  return _vm.checkConfirm(e.target.value)
                }
              ]
            }
          })
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-32aa4520", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-32aa4520","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./seventytwo/72cms-ui/src/components/form-elements/PasswordConfirmComponent.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-32aa4520","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./seventytwo/72cms-ui/src/components/form-elements/PasswordConfirmComponent.vue
// module chunks = 0